export const FETCHING_SEARCH_RESULTS = 'FETCHING_SEARCH_RESULTS';
export const FETCH_FAILURE = 'FETCH_FAILURE';
export const FETCH_SEARCH_SUCCESS = 'FETCH_SEARCH_SUCCESS';
export const CLOSE_SEARCH_RESULTS = 'CLOSE_SEARCH_RESULTS';
export const FETCH_SEARCH_NOTFOUND = 'FETCH_SEARCH_NOTFOUND';
